/** Locale BCP 47 para formatear fechas según idioma del flujo (mini-app). */
export function localeTagFromLang(language?: string): string {
  const code = (language || 'es').split(/[-_]/)[0]?.toLowerCase() || 'es';
  switch (code) {
    case 'en':
      return 'en-GB';
    case 'fr':
      return 'fr-FR';
    case 'de':
      return 'de-DE';
    case 'pt':
      return 'pt-PT';
    case 'es':
    default:
      return 'es-ES';
  }
}

/** Fecha `YYYY-MM-DD` → texto corto localizado (p. ej. vie., 8 may → Thu, 8 May en EN). */
export function formatBookingDateShort(isoDate: string, localeTag: string): string {
  const raw = isoDate?.slice(0, 10);
  const [y, m, d] = (raw || '').split('-').map(Number);
  if (!y || !m || !d) return isoDate || '';
  const dt = new Date(y, m - 1, d);
  return dt.toLocaleDateString(localeTag, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
  });
}
